import { requiredField } from "helpers/validators";

const config = {
    text: {
        // field
        label: "Текст ответа",
        inputProps: { name: "text" },
        validators: [requiredField],
        required: true,
    },
    nextQuestionId: {
        // select
        label: "Следующий вопрос",
        inputProps: { name: "nextQuestionId" },
        options: [],
        menuPortalTarget: document.body,
    },
    externalData: {
        value: { propertyName: "" },
        config: {
            propertyName: {
                // field
                label: "PropertyName",
                inputProps: { name: "propertyName" },
            },
        },
    },
    id: {},
    order: {},
    questionId: {},
    scenarioId: {},
};

export { config };
